"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DatePicker_meta_1 = require("../DatePicker.meta");
var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");
var rawCssPrefix = "\ndisplay: inline-block;\nfont-weight: 600;\nmax-width: 84%;\noverflow: hidden;\ntext-overflow: ellipsis;\nwhite-space: nowrap;\n\n@media (min-width: 36em) {\n\tdisplay: none;\n}\n";
exports.default = InjectedStyledComponent_1.InjectedStyledComponent('label', DatePicker_meta_1.DATE_PICKER_CATEGORY_KEY, DatePicker_meta_1.DATE_PICKER_COMPONENT_KEY, ['mobileHeading'], rawCssPrefix);
